// date function that formats date object to yyyy-mm-dd string
export function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

// date function that parses yyyy-mm-dd string to date object
export function parseDate(dateString) {
  const [year, month, day] = dateString.split("-");
  return new Date(year, month - 1, day); // Months are 0-indexed
}

// date function that checks if a date is today
export function isToday(date) {
  const today = new Date();
  const dateToCheck = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  );
  return dateToCheck.toDateString() === today.toDateString();
}

// date function that checks if a date is in the past
export function onlyToday(date) {
  if (date === null) {
    return null;
  }
  const parsedDate = new Date(date);
  return isToday(parsedDate) ? parsedDate : null;
}
